import React from 'react';

const baseClasses =
  'inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed';

const variantClasses: Record<NonNullable<ButtonProps['variant']>, string> = {
  primary: 'bg-teal-600 text-white hover:bg-teal-700',
  dark: 'bg-slate-900 text-white hover:bg-slate-800',
  outline: 'bg-white border border-slate-300 text-slate-700 hover:bg-slate-50',
  ghost: 'text-slate-500 hover:text-slate-700 hover:bg-slate-100',
  danger: 'text-red-600 hover:text-red-700 hover:bg-red-50'
};

const sizeClasses: Record<NonNullable<ButtonProps['size']>, string> = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2 text-sm',
  lg: 'px-6 py-3 text-base'
};

export type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'primary' | 'dark' | 'outline' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
};

export const Button: React.FC<ButtonProps> = ({
  variant = 'outline',
  size = 'md',
  className = '',
  ...props
}) => (
  <button
    className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}
    {...props}
  />
);
